import { Stack } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'
import Typography from '@mui/material/Typography'
import { find } from 'lodash'
import * as React from 'react'
import { useEffect } from 'react'
import { useWrapperStore } from '../../store/storeWrapper'

export const ProjectItem = ({ projectId }) => {
    const { projectListFull } = useWrapperStore((state) => state)
    const [projectDetail, setProjectDetail] = React.useState(undefined)

    useEffect(() => {
        if (projectListFull) {
            const projectDetailFind = find(projectListFull, (item) => {
                return item.id === projectId
            })
            const projectDetail = projectDetailFind
                ? { color: '#006CFD', title: projectDetailFind.title }
                : { color: '#999999', title: 'Без проекта' }
            setProjectDetail(projectDetail)
        }
    }, [projectListFull])

    return (
        <Stack
            sx={{
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: '4px',
                minWidth: 0,
            }}>
            {projectDetail ? (
                <>
                    <Typography
                        variant="caption2"
                        sx={{
                            color: '#9195A1',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}>
                        {projectDetail.title}
                    </Typography>
                </>
            ) : (
                <Skeleton
                    variant="rectangular"
                    width="90%"
                    height={16}
                    sx={{ borderRadius: '24px' }}
                />
            )}
        </Stack>
    )
}
